webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tinycolor = __webpack_require__(33);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _colorChange(data, oldHue) {
  var alpha = data && data.a;
  var color;

  if (data && data.hsl) {
    color = (0, _tinycolor2.default)(data.hsl);
  } else if (data && data.hex && data.hex.length > 0) {
    color = (0, _tinycolor2.default)(data.hex);
  } else if (data && data.hsv) {
    color = (0, _tinycolor2.default)(data.hsv);
  } else if (data && data.rgba) {
    color = (0, _tinycolor2.default)(data.rgba);
  } else if (data && data.rgb) {
    color = (0, _tinycolor2.default)(data.rgb);
  } else {
    color = (0, _tinycolor2.default)(data);
  }

  if (color && (color._a === undefined || color._a === null)) {
    color.setAlpha(alpha || 1);
  }

  var hsl = color.toHsl();
  var hsv = color.toHsv();

  if (hsl.s === 0) {
    hsv.h = hsl.h = data.h || data.hsl && data.hsl.h || oldHue || 0;
  }

  return {
    hsl: hsl,
    hex: color.toHexString().toUpperCase(),
    hex8: color.toHex8String().toUpperCase(),
    rgba: color.toRgb(),
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source,
    a: data.a || color.getAlpha()
  };
}

exports.default = {
  props: ['value'],
  data: function data() {
    return {
      val: _colorChange(this.value)
    };
  },

  computed: {
    colors: {
      get: function get() {
        return this.val;
      },
      set: function set(newVal) {
        this.val = newVal;
        this.$emit('input', newVal);
      }
    }
  },
  watch: {
    value: function value(newVal) {
      this.val = _colorChange(newVal);
    }
  },
  methods: {
    colorChange: function colorChange(data, oldHue) {
      this.oldHue = this.colors.hsl.h;
      this.colors = _colorChange(data, oldHue || this.oldHue);
    },
    isValidHex: function isValidHex(hex) {
      return (0, _tinycolor2.default)(hex).isValid();
    },
    simpleCheckForValidColor: function simpleCheckForValidColor(data) {
      var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
      var checked = 0;
      var passed = 0;

      for (var i = 0; i < keysToCheck.length; i++) {
        var letter = keysToCheck[i];
        if (data[letter]) {
          checked++;
          if (!isNaN(data[letter])) {
            passed++;
          }
        }
      }

      if (checked === passed) {
        return data;
      }
    },
    paletteUpperCase: function paletteUpperCase(palette) {
      return palette.map(function (c) {
        return c.toUpperCase();
      });
    },
    isTransparent: function isTransparent(color) {
      return (0, _tinycolor2.default)(color).getAlpha() === 0;
    }
  }
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditableInput_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditableInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditableInput_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditableInput_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditableInput_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd564b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditableInput_vue__ = __webpack_require__(32);
function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditableInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd564b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditableInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hue_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hue_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hue_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hue_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hue_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7891f96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hue_vue__ = __webpack_require__(48);
function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hue_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7891f96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Saturation_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Saturation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Saturation_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Saturation_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Saturation_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff9e1348_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Saturation_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Saturation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff9e1348_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Saturation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alpha_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alpha_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alpha_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alpha_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alpha_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316fbb62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alpha_vue__ = __webpack_require__(59);
function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alpha_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316fbb62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alpha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkboard_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkboard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f801d328_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkboard_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f801d328_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Material = __webpack_require__(29);

var _Material2 = _interopRequireDefault(_Material);

var _Compact = __webpack_require__(35);

var _Compact2 = _interopRequireDefault(_Compact);

var _Grayscale = __webpack_require__(38);

var _Grayscale2 = _interopRequireDefault(_Grayscale);

var _Swatches = __webpack_require__(41);

var _Swatches2 = _interopRequireDefault(_Swatches);

var _Slider = __webpack_require__(45);

var _Slider2 = _interopRequireDefault(_Slider);

var _Sketch = __webpack_require__(50);

var _Sketch2 = _interopRequireDefault(_Sketch);

var _Chrome = __webpack_require__(61);

var _Chrome2 = _interopRequireDefault(_Chrome);

var _Photoshop = __webpack_require__(64);

var _Photoshop2 = _interopRequireDefault(_Photoshop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  hex: '#194d33e6',
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 0.9
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.30,
    a: 0.9
  },
  rgba: {
    r: 159,
    g: 96,
    b: 43,
    a: 0.9
  },
  a: 0.9
};

exports.default = {
  components: {
    'material-picker': _Material2.default,
    'compact-picker': _Compact2.default,
    'grayscale-picker': _Grayscale2.default,
    'swatches-picker': _Swatches2.default,
    'slider-picker': _Slider2.default,
    'sketch-picker': _Sketch2.default,
    'chrome-picker': _Chrome2.default,
    'photoshop-picker': _Photoshop2.default
  },
  data: function data() {
    return {
      colors: defaultProps
    };
  },

  computed: {
    bgc: function bgc() {
      return this.colors.hex;
    }
  },
  methods: {
    onOk: function onOk() {
      console.log('ok');
    },
    onCancel: function onCancel() {
      console.log('cancel');
    },
    updateValue: function updateValue(value) {
      this.colors = value;
    }
  },
  created: function created() {}
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditableInput = __webpack_require__(2);

var _EditableInput2 = _interopRequireDefault(_EditableInput);

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Material',
  mixins: [_color2.default],
  components: {
    'ed-in': _EditableInput2.default
  },
  methods: {
    onChange: function onChange(data) {
      if (!data) {
        return;
      }
      if (data.hex) {
        this.isValidHex(data.hex) && this.colorChange({
          hex: data.hex,
          source: 'hex'
        });
      } else if (data.r || data.g || data.b) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      }
    }
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'editableInput',
  props: {
    label: String,
    labelText: String,
    desc: String,
    value: [String, Number],
    max: Number,
    min: Number,
    arrowOffset: {
      type: Number,
      default: 1
    }
  },
  computed: {
    val: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        if (!(this.max === undefined) && +v > this.max) {
          this.$refs.input.value = this.max;
        } else {
          return v;
        }
      }
    },
    labelId: function labelId() {
      return 'input__label__' + this.label + '__' + Math.random().toString().slice(2, 5);
    },
    labelSpanText: function labelSpanText() {
      return this.labelText || this.label;
    }
  },
  methods: {
    update: function update(e) {
      this.handleChange(e.target.value);
    },
    handleChange: function handleChange(newVal) {
      var data = {};
      data[this.label] = newVal;
      if (data.hex === undefined && data['#'] === undefined) {
        this.$emit('change', data);
      } else if (newVal.length > 5) {
        this.$emit('change', data);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var val = this.val;
      var number = Number(val);

      if (number) {
        var amount = this.arrowOffset || 1;

        if (e.keyCode === 38) {
          val = number + amount;
          this.handleChange(val);
          e.preventDefault();
        }

        if (e.keyCode === 40) {
          val = number - amount;
          this.handleChange(val);
          e.preventDefault();
        }
      }
    }
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

var _EditableInput = __webpack_require__(2);

var _EditableInput2 = _interopRequireDefault(_EditableInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultColors = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#CCCCCC', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'];

exports.default = {
  name: 'Compact',
  mixins: [_color2.default],
  props: {
    palette: {
      type: Array,
      default: function _default() {
        return defaultColors;
      }
    }
  },
  components: {
    'ed-in': _EditableInput2.default
  },
  computed: {
    pick: function pick() {
      return this.colors.hex.toUpperCase();
    }
  },
  methods: {
    handlerClick: function handlerClick(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
    }
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultColors = ['#FFFFFF', '#F2F2F2', '#E6E6E6', '#D9D9D9', '#CCCCCC', '#BFBFBF', '#B3B3B3', '#A6A6A6', '#999999', '#8C8C8C', '#808080', '#737373', '#666666', '#595959', '#4D4D4D', '#404040', '#333333', '#262626', '#0D0D0D', '#000000'];

exports.default = {
  name: 'Grayscale',
  mixins: [_color2.default],
  props: {
    palette: {
      type: Array,
      default: function _default() {
        return defaultColors;
      }
    }
  },
  components: {},
  computed: {
    pick: function pick() {
      return this.colors.hex.toUpperCase();
    }
  },
  methods: {
    handlerClick: function handlerClick(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
    }
  }
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _materialColors = __webpack_require__(43);

var _materialColors2 = _interopRequireDefault(_materialColors);

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorMap = ['red', 'pink', 'purple', 'deepPurple', 'indigo', 'blue', 'lightBlue', 'cyan', 'teal', 'green', 'lightGreen', 'lime', 'yellow', 'amber', 'orange', 'deepOrange', 'brown', 'blueGrey', 'black'];
var colorLevel = ['900', '700', '500', '300', '100'];
var defaultColors = function () {
  var colors = [];
  colorMap.forEach(function (type) {
    var typeColor = [];
    if (type.toLowerCase() === 'black' || type.toLowerCase() === 'white') {
      typeColor = typeColor.concat(['#000000', '#FFFFFF']);
    } else {
      colorLevel.forEach(function (level) {
        var color = _materialColors2.default[type][level];
        typeColor.push(color.toUpperCase());
      });
    }
    colors.push(typeColor);
  });
  return colors;
}();

exports.default = {
  name: 'Swatches',
  mixins: [_color2.default],
  props: {
    palette: {
      type: Array,
      default: function _default() {
        return defaultColors;
      }
    }
  },
  computed: {
    pick: function pick() {
      return this.colors.hex;
    }
  },
  methods: {
    equal: function equal(color) {
      return color.toLowerCase() === this.colors.hex.toLowerCase();
    },
    handlerClick: function handlerClick(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
    }
  }

};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

var _Hue = __webpack_require__(3);

var _Hue2 = _interopRequireDefault(_Hue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Slider',
  mixins: [_color2.default],
  props: {
    swatches: {
      type: Array,
      default: function _default() {
        return ['.80', '.65', '.50', '.35', '.20'];
      }
    }
  },
  components: {
    hue: _Hue2.default
  },
  computed: {
    activeOffset: function activeOffset() {
      var hasBlack = this.swatches.includes('0');
      var hasWhite = this.swatches.includes('1');
      var hsl = this.colors.hsl;

      if (Math.round(hsl.s * 100) / 100 === 0.50) {
        return Math.round(hsl.l * 100) / 100;
      } else if (hasBlack && hsl.l === 0) {
        return 0;
      } else if (hasWhite && hsl.l === 1) {
        return 1;
      }
      return -1;
    }
  },
  methods: {
    hueChange: function hueChange(data) {
      this.colorChange(data);
    },
    handleSwClick: function handleSwClick(index, offset) {
      this.colorChange({
        h: this.colors.hsl.h,
        s: 0.5,
        l: offset,
        source: 'hsl'
      });
    }
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Hue',
  props: {
    value: Object,
    direction: {
      type: String,

      default: 'horizontal'
    }
  },
  data: function data() {
    return {
      oldHue: 0,
      pullDirection: ''
    };
  },

  computed: {
    colors: function colors() {
      var h = this.value.hsl.h;
      if (h !== 0 && h - this.oldHue > 0) this.pullDirection = 'right';
      if (h !== 0 && h - this.oldHue < 0) this.pullDirection = 'left';
      this.oldHue = h;

      return this.value;
    },
    directionClass: function directionClass() {
      return {
        'vc-hue--horizontal': this.direction === 'horizontal',
        'vc-hue--vertical': this.direction === 'vertical'
      };
    },
    pointerTop: function pointerTop() {
      if (this.direction === 'vertical') {
        if (this.colors.hsl.h === 0 && this.pullDirection === 'right') return 0;
        return -(this.colors.hsl.h * 100 / 360) + 100 + '%';
      } else {
        return 0;
      }
    },
    pointerLeft: function pointerLeft() {
      if (this.direction === 'vertical') {
        return 0;
      } else {
        if (this.colors.hsl.h === 0 && this.pullDirection === 'right') return '100%';
        return this.colors.hsl.h * 100 / 360 + '%';
      }
    }
  },
  methods: {
    handleChange: function handleChange(e, skip) {
      !skip && e.preventDefault();

      var container = this.$refs.container;
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
      var left = pageX - xOffset;
      var top = pageY - yOffset;

      var h;
      var percent;

      if (this.direction === 'vertical') {
        if (top < 0) {
          h = 360;
        } else if (top > containerHeight) {
          h = 0;
        } else {
          percent = -(top * 100 / containerHeight) + 100;
          h = 360 * percent / 100;
        }

        if (this.colors.hsl.h !== h) {
          this.$emit('change', {
            h: h,
            s: this.colors.hsl.s,
            l: this.colors.hsl.l,
            a: this.colors.hsl.a,
            source: 'hsl'
          });
        }
      } else {
        if (left < 0) {
          h = 0;
        } else if (left > containerWidth) {
          h = 360;
        } else {
          percent = left * 100 / containerWidth;
          h = 360 * percent / 100;
        }

        if (this.colors.hsl.h !== h) {
          this.$emit('change', {
            h: h,
            s: this.colors.hsl.s,
            l: this.colors.hsl.l,
            a: this.colors.hsl.a,
            source: 'hsl'
          });
        }
      }
    },
    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp(e) {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

var _EditableInput = __webpack_require__(2);

var _EditableInput2 = _interopRequireDefault(_EditableInput);

var _Saturation = __webpack_require__(4);

var _Saturation2 = _interopRequireDefault(_Saturation);

var _Hue = __webpack_require__(3);

var _Hue2 = _interopRequireDefault(_Hue);

var _Alpha = __webpack_require__(5);

var _Alpha2 = _interopRequireDefault(_Alpha);

var _Checkboard = __webpack_require__(6);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var presetColors = ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF', 'rgba(0,0,0,0)'];

exports.default = {
  name: 'Sketch',
  mixins: [_color2.default],
  components: {
    saturation: _Saturation2.default,
    hue: _Hue2.default,
    alpha: _Alpha2.default,
    'ed-in': _EditableInput2.default,
    checkboard: _Checkboard2.default
  },
  props: {
    presetColors: {
      type: Array,
      default: function _default() {
        return presetColors;
      }
    },
    disableAlpha: {
      type: Boolean,
      default: false
    },
    disableFields: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hex: function hex() {
      var hex = void 0;
      if (this.colors.a < 1) {
        hex = this.colors.hex8;
      } else {
        hex = this.colors.hex;
      }
      return hex.replace('#', '');
    },
    activeColor: function activeColor() {
      var rgba = this.colors.rgba;
      return 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')';
    }
  },
  methods: {
    handlePreset: function handlePreset(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
    },
    childChange: function childChange(data) {
      this.colorChange(data);
    },
    inputChange: function inputChange(data) {
      if (!data) {
        return;
      }
      if (data.hex) {
        this.isValidHex(data.hex) && this.colorChange({
          hex: data.hex,
          source: 'hex'
        });
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      }
    }
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clamp = __webpack_require__(53);

var _clamp2 = _interopRequireDefault(_clamp);

var _lodash = __webpack_require__(54);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Saturation',
  props: {
    value: Object
  },
  computed: {
    colors: function colors() {
      return this.value;
    },
    bgColor: function bgColor() {
      return 'hsl(' + this.colors.hsv.h + ', 100%, 50%)';
    },
    pointerTop: function pointerTop() {
      return -(this.colors.hsv.v * 100) + 1 + 100 + '%';
    },
    pointerLeft: function pointerLeft() {
      return this.colors.hsv.s * 100 + '%';
    }
  },
  methods: {
    throttle: (0, _lodash2.default)(function (fn, data) {
      fn(data);
    }, 20, {
      'leading': true,
      'trailing': false
    }),
    handleChange: function handleChange(e, skip) {
      !skip && e.preventDefault();
      var container = this.$refs.container;
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
      var left = (0, _clamp2.default)(pageX - xOffset, 0, containerWidth);
      var top = (0, _clamp2.default)(pageY - yOffset, 0, containerHeight);
      var saturation = left / containerWidth;
      var bright = (0, _clamp2.default)(-(top / containerHeight) + 1, 0, 1);

      this.throttle(this.onChange, {
        h: this.colors.hsv.h,
        s: saturation,
        v: bright,
        a: this.colors.hsv.a,
        source: 'hsva'
      });
    },
    onChange: function onChange(param) {
      this.$emit('change', param);
    },
    handleMouseDown: function handleMouseDown(e) {
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp(e) {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkboard = __webpack_require__(6);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Alpha',
  props: {
    value: Object,
    onChange: Function
  },
  components: {
    checkboard: _Checkboard2.default
  },
  computed: {
    colors: function colors() {
      return this.value;
    },
    gradientColor: function gradientColor() {
      var rgba = this.colors.rgba;
      var rgbStr = [rgba.r, rgba.g, rgba.b].join(',');
      return 'linear-gradient(to right, rgba(' + rgbStr + ', 0) 0%, rgba(' + rgbStr + ', 1) 100%)';
    }
  },
  methods: {
    handleChange: function handleChange(e, skip) {
      !skip && e.preventDefault();
      var container = this.$refs.container;
      var containerWidth = container.clientWidth;

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var left = pageX - xOffset;

      var a;
      if (left < 0) {
        a = 0;
      } else if (left > containerWidth) {
        a = 1;
      } else {
        a = Math.round(left * 100 / containerWidth) / 100;
      }

      if (this.colors.a !== a) {
        this.$emit('change', {
          h: this.colors.hsl.h,
          s: this.colors.hsl.s,
          l: this.colors.hsl.l,
          a: a,
          source: 'rgba'
        });
      }
    },
    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var _checkboardCache = {};

exports.default = {
  name: 'Checkboard',
  props: {
    size: {
      type: [Number, String],
      default: 8
    },
    white: {
      type: String,
      default: '#fff'
    },
    grey: {
      type: String,
      default: '#e6e6e6'
    }
  },
  computed: {
    bgStyle: function bgStyle() {
      return {
        'background-image': 'url(' + getCheckboard(this.white, this.grey, this.size) + ')'
      };
    }
  }
};


function renderCheckboard(c1, c2, size) {
  if (typeof document === 'undefined') {
    return null;
  }
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = size * 2;
  var ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  }
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
}

function getCheckboard(c1, c2, size) {
  var key = c1 + ',' + c2 + ',' + size;

  if (_checkboardCache[key]) {
    return _checkboardCache[key];
  } else {
    var checkboard = renderCheckboard(c1, c2, size);
    _checkboardCache[key] = checkboard;
    return checkboard;
  }
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

var _EditableInput = __webpack_require__(2);

var _EditableInput2 = _interopRequireDefault(_EditableInput);

var _Saturation = __webpack_require__(4);

var _Saturation2 = _interopRequireDefault(_Saturation);

var _Hue = __webpack_require__(3);

var _Hue2 = _interopRequireDefault(_Hue);

var _Alpha = __webpack_require__(5);

var _Alpha2 = _interopRequireDefault(_Alpha);

var _Checkboard = __webpack_require__(6);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Chrome',
  mixins: [_color2.default],
  props: {
    disableAlpha: {
      type: Boolean,
      default: false
    },
    disableFields: {
      type: Boolean,
      default: false
    }
  },
  components: {
    saturation: _Saturation2.default,
    hue: _Hue2.default,
    alpha: _Alpha2.default,
    'ed-in': _EditableInput2.default,
    checkboard: _Checkboard2.default
  },
  data: function data() {
    return {
      fieldsIndex: 0,
      highlight: false
    };
  },

  computed: {
    hsl: function hsl() {
      var _colors$hsl = this.colors.hsl,
          h = _colors$hsl.h,
          s = _colors$hsl.s,
          l = _colors$hsl.l;

      return {
        h: h.toFixed(),
        s: (s * 100).toFixed() + '%',
        l: (l * 100).toFixed() + '%'
      };
    },
    activeColor: function activeColor() {
      var rgba = this.colors.rgba;
      return 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')';
    },
    hasAlpha: function hasAlpha() {
      return this.colors.a < 1;
    }
  },
  methods: {
    childChange: function childChange(data) {
      this.colorChange(data);
    },
    inputChange: function inputChange(data) {
      if (!data) {
        return;
      }
      if (data.hex) {
        this.isValidHex(data.hex) && this.colorChange({
          hex: data.hex,
          source: 'hex'
        });
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      } else if (data.h || data.s || data.l) {
        var s = data.s ? data.s.replace('%', '') / 100 : this.colors.hsl.s;
        var l = data.l ? data.l.replace('%', '') / 100 : this.colors.hsl.l;

        this.colorChange({
          h: data.h || this.colors.hsl.h,
          s: s,
          l: l,
          source: 'hsl'
        });
      }
    },
    toggleViews: function toggleViews() {
      if (this.fieldsIndex >= 2) {
        this.fieldsIndex = 0;
        return;
      }
      this.fieldsIndex++;
    },
    showHighlight: function showHighlight() {
      this.highlight = true;
    },
    hideHighlight: function hideHighlight() {
      this.highlight = false;
    }
  }
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = __webpack_require__(1);

var _color2 = _interopRequireDefault(_color);

var _EditableInput = __webpack_require__(2);

var _EditableInput2 = _interopRequireDefault(_EditableInput);

var _Saturation = __webpack_require__(4);

var _Saturation2 = _interopRequireDefault(_Saturation);

var _Hue = __webpack_require__(3);

var _Hue2 = _interopRequireDefault(_Hue);

var _Alpha = __webpack_require__(5);

var _Alpha2 = _interopRequireDefault(_Alpha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Photoshop',
  mixins: [_color2.default],
  props: {
    head: {
      type: String,
      default: 'Color Picker'
    },
    disableFields: {
      type: Boolean,
      default: false
    },
    hasResetButton: {
      type: Boolean,
      default: false
    },
    acceptLabel: {
      type: String,
      default: 'OK'
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    },
    resetLabel: {
      type: String,
      default: 'Reset'
    },
    newLabel: {
      type: String,
      default: 'new'
    },
    currentLabel: {
      type: String,
      default: 'current'
    }
  },
  components: {
    saturation: _Saturation2.default,
    hue: _Hue2.default,
    alpha: _Alpha2.default,
    'ed-in': _EditableInput2.default
  },
  data: function data() {
    return {
      currentColor: '#FFF'
    };
  },

  computed: {
    hsv: function hsv() {
      var hsv = this.colors.hsv;
      return {
        h: hsv.h.toFixed(),
        s: (hsv.s * 100).toFixed(),
        v: (hsv.v * 100).toFixed()
      };
    },
    hex: function hex() {
      var hex = this.colors.hex;
      return hex && hex.replace('#', '');
    }
  },
  created: function created() {
    this.currentColor = this.colors.hex;
  },

  methods: {
    childChange: function childChange(data) {
      this.colorChange(data);
    },
    inputChange: function inputChange(data) {
      if (!data) {
        return;
      }
      if (data['#']) {
        this.isValidHex(data['#']) && this.colorChange({
          hex: data['#'],
          source: 'hex'
        });
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      } else if (data.h || data.s || data.v) {
        this.colorChange({
          h: data.h || this.colors.hsv.h,
          s: data.s / 100 || this.colors.hsv.s,
          v: data.v / 100 || this.colors.hsv.v,
          source: 'hsv'
        });
      }
    },
    clickCurrentColor: function clickCurrentColor() {
      this.colorChange({
        hex: this.currentColor,
        source: 'hex'
      });
    },
    handleAccept: function handleAccept() {
      this.$emit('ok');
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    handleReset: function handleReset() {
      this.$emit('reset');
    }
  }

};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vueMin = __webpack_require__(22);

var _vueMin2 = _interopRequireDefault(_vueMin);

var _App = __webpack_require__(26);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log(_vueMin2.default.version);
new _vueMin2.default({
  el: '#app-wrap',
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b7b42a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b7b42a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Material_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Material_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Material_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Material_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Material_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a82618_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Material_vue__ = __webpack_require__(34);
function injectStyle (ssrContext) {
  __webpack_require__(30)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Material_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a82618_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Material_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-editable-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"input",staticClass:"vc-input__input",attrs:{"aria-labelledby":_vm.labelId},domProps:{"value":(_vm.val)},on:{"keydown":_vm.handleKeyDown,"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},_vm.update]}}),_vm._v(" "),_c('span',{staticClass:"vc-input__label",attrs:{"for":_vm.label,"id":_vm.labelId}},[_vm._v(_vm._s(_vm.labelSpanText))]),_vm._v(" "),_c('span',{staticClass:"vc-input__desc"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-material",attrs:{"role":"application","aria-label":"Material color picker"}},[_c('ed-in',{staticClass:"vc-material-hex",style:({ borderColor: _vm.colors.hex }),attrs:{"label":"hex"},on:{"change":_vm.onChange},model:{value:(_vm.colors.hex),callback:function ($$v) {_vm.$set(_vm.colors, "hex", $$v)},expression:"colors.hex"}}),_vm._v(" "),_c('div',{staticClass:"vc-material-split"},[_c('div',{staticClass:"vc-material-third"},[_c('ed-in',{attrs:{"label":"r"},on:{"change":_vm.onChange},model:{value:(_vm.colors.rgba.r),callback:function ($$v) {_vm.$set(_vm.colors.rgba, "r", $$v)},expression:"colors.rgba.r"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-material-third"},[_c('ed-in',{attrs:{"label":"g"},on:{"change":_vm.onChange},model:{value:(_vm.colors.rgba.g),callback:function ($$v) {_vm.$set(_vm.colors.rgba, "g", $$v)},expression:"colors.rgba.g"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-material-third"},[_c('ed-in',{attrs:{"label":"b"},on:{"change":_vm.onChange},model:{value:(_vm.colors.rgba.b),callback:function ($$v) {_vm.$set(_vm.colors.rgba, "b", $$v)},expression:"colors.rgba.b"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compact_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compact_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compact_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compact_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58aeaae0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compact_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compact_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58aeaae0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-compact",attrs:{"role":"application","aria-label":"Compact color picker"}},[_c('ul',{staticClass:"vc-compact-colors",attrs:{"role":"listbox"}},_vm._l((_vm.paletteUpperCase(_vm.palette)),function(c){return _c('li',{key:c,staticClass:"vc-compact-color-item",class:{'vc-compact-color-item--white': c === '#FFFFFF' },style:({background: c}),attrs:{"role":"option","aria-label":'color:' + c,"aria-selected":c === _vm.pick},on:{"click":function($event){_vm.handlerClick(c)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(c === _vm.pick),expression:"c === pick"}],staticClass:"vc-compact-dot"})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grayscale_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grayscale_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grayscale_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grayscale_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grayscale_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c586612a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grayscale_vue__ = __webpack_require__(40);
function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grayscale_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c586612a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grayscale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-grayscale",attrs:{"role":"application","aria-label":"Grayscale color picker"}},[_c('ul',{staticClass:"vc-grayscale-colors",attrs:{"role":"listbox"}},_vm._l((_vm.paletteUpperCase(_vm.palette)),function(c){return _c('li',{key:c,staticClass:"vc-grayscale-color-item",class:{'vc-grayscale-color-item--white': c == '#FFFFFF'},style:({background: c}),attrs:{"role":"option","aria-label":'Color:' + c,"aria-selected":c === _vm.pick},on:{"click":function($event){_vm.handlerClick(c)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(c === _vm.pick),expression:"c === pick"}],staticClass:"vc-grayscale-dot"})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swatches_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swatches_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swatches_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swatches_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swatches_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d04c0fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Swatches_vue__ = __webpack_require__(44);
function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Swatches_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d04c0fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Swatches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-swatches",attrs:{"role":"application","aria-label":"Swatches color picker","data-pick":_vm.pick}},[_c('div',{staticClass:"vc-swatches-box",attrs:{"role":"listbox"}},_vm._l((_vm.palette),function(group,$idx){return _c('div',{key:$idx,staticClass:"vc-swatches-color-group"},_vm._l((group),function(c){return _c('div',{key:c,class:['vc-swatches-color-it', {'vc-swatches-color--white': c === '#FFFFFF' }],style:({background: c}),attrs:{"role":"option","aria-label":'Color:' + c,"aria-selected":_vm.equal(c),"data-color":c},on:{"click":function($event){_vm.handlerClick(c)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.equal(c)),expression:"equal(c)"}],staticClass:"vc-swatches-pick"},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"}})])])])}))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7083ea24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__ = __webpack_require__(49);
function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7083ea24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vc-hue', _vm.directionClass]},[_c('div',{ref:"container",staticClass:"vc-hue-container",attrs:{"role":"slider","aria-valuenow":_vm.colors.hsl.h,"aria-valuemin":"0","aria-valuemax":"360"},on:{"mousedown":_vm.handleMouseDown,"touchmove":_vm.handleChange,"touchstart":_vm.handleChange}},[_c('div',{staticClass:"vc-hue-pointer",style:({top: _vm.pointerTop, left: _vm.pointerLeft}),attrs:{"role":"presentation"}},[_c('div',{staticClass:"vc-hue-picker"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-slider",attrs:{"role":"application","aria-label":"Slider color picker"}},[_c('div',{staticClass:"vc-slider-hue-warp"},[_c('hue',{on:{"change":_vm.hueChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-slider-swatches",attrs:{"role":"group"}},_vm._l((_vm.swatches),function(offset,index){return _c('div',{key:index,staticClass:"vc-slider-swatch",attrs:{"data-index":index,"aria-label":'color:' + _vm.colors.hex,"role":"button"},on:{"click":function($event){_vm.handleSwClick(index, offset)}}},[_c('div',{staticClass:"vc-slider-swatch-picker",class:{'vc-slider-swatch-picker--active': offset == _vm.activeOffset, 'vc-slider-swatch-picker--white': offset === '1'},style:({background: 'hsl(' + _vm.colors.hsl.h + ', 50%, ' + (offset * 100) + '%)'})})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sketch_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sketch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sketch_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sketch_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sketch_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791cad92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sketch_vue__ = __webpack_require__(60);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sketch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791cad92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sketch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"vc-saturation",style:({background: _vm.bgColor}),on:{"mousedown":_vm.handleMouseDown,"touchmove":_vm.handleChange,"touchstart":_vm.handleChange}},[_c('div',{staticClass:"vc-saturation--white"}),_vm._v(" "),_c('div',{staticClass:"vc-saturation--black"}),_vm._v(" "),_c('div',{staticClass:"vc-saturation-pointer",style:({top: _vm.pointerTop, left: _vm.pointerLeft})},[_c('div',{staticClass:"vc-saturation-circle"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-checkerboard",style:(_vm.bgStyle)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-alpha"},[_c('div',{staticClass:"vc-alpha-checkboard-wrap"},[_c('checkboard')],1),_vm._v(" "),_c('div',{staticClass:"vc-alpha-gradient",style:({background: _vm.gradientColor})}),_vm._v(" "),_c('div',{ref:"container",staticClass:"vc-alpha-container",on:{"mousedown":_vm.handleMouseDown,"touchmove":_vm.handleChange,"touchstart":_vm.handleChange}},[_c('div',{staticClass:"vc-alpha-pointer",style:({left: _vm.colors.a * 100 + '%'})},[_c('div',{staticClass:"vc-alpha-picker"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vc-sketch', _vm.disableAlpha ? 'vc-sketch__disable-alpha' : ''],attrs:{"role":"application","aria-label":"Sketch color picker"}},[_c('div',{staticClass:"vc-sketch-saturation-wrap"},[_c('saturation',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-sketch-controls"},[_c('div',{staticClass:"vc-sketch-sliders"},[_c('div',{staticClass:"vc-sketch-hue-wrap"},[_c('hue',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-sketch-alpha-wrap"},[_c('alpha',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"vc-sketch-color-wrap"},[_c('div',{staticClass:"vc-sketch-active-color",style:({background: _vm.activeColor}),attrs:{"aria-label":("Current color is " + _vm.activeColor)}}),_vm._v(" "),_c('checkboard')],1)]),_vm._v(" "),(!_vm.disableFields)?_c('div',{staticClass:"vc-sketch-field"},[_c('div',{staticClass:"vc-sketch-field--double"},[_c('ed-in',{attrs:{"label":"hex","value":_vm.hex},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-sketch-field--single"},[_c('ed-in',{attrs:{"label":"r","value":_vm.colors.rgba.r},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-sketch-field--single"},[_c('ed-in',{attrs:{"label":"g","value":_vm.colors.rgba.g},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-sketch-field--single"},[_c('ed-in',{attrs:{"label":"b","value":_vm.colors.rgba.b},on:{"change":_vm.inputChange}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-sketch-field--single"},[_c('ed-in',{attrs:{"label":"a","value":_vm.colors.a,"arrow-offset":0.01,"max":1},on:{"change":_vm.inputChange}})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vc-sketch-presets",attrs:{"role":"group","aria-label":"A color preset, pick one to set as current color"}},[_vm._l((_vm.presetColors),function(c){return [(!_vm.isTransparent(c))?_c('div',{key:c,staticClass:"vc-sketch-presets-color",style:({background: c}),attrs:{"aria-label":'Color:' + c},on:{"click":function($event){_vm.handlePreset(c)}}}):_c('div',{key:c,staticClass:"vc-sketch-presets-color",attrs:{"aria-label":'Color:' + c},on:{"click":function($event){_vm.handlePreset(c)}}},[_c('checkboard')],1)]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chrome_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chrome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chrome_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chrome_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chrome_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08c6ce3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chrome_vue__ = __webpack_require__(63);
function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chrome_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08c6ce3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chrome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vc-chrome', _vm.disableAlpha ? 'vc-chrome__disable-alpha' : ''],attrs:{"role":"application","aria-label":"Chrome color picker"}},[_c('div',{staticClass:"vc-chrome-saturation-wrap"},[_c('saturation',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-body"},[_c('div',{staticClass:"vc-chrome-controls"},[_c('div',{staticClass:"vc-chrome-color-wrap"},[_c('div',{staticClass:"vc-chrome-active-color",style:({background: _vm.activeColor}),attrs:{"aria-label":("current color is " + (_vm.colors.hex))}}),_vm._v(" "),(!_vm.disableAlpha)?_c('checkboard'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-sliders"},[_c('div',{staticClass:"vc-chrome-hue-wrap"},[_c('hue',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-chrome-alpha-wrap"},[_c('alpha',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1):_vm._e()])]),_vm._v(" "),(!_vm.disableFields)?_c('div',{staticClass:"vc-chrome-fields-wrap"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fieldsIndex === 0),expression:"fieldsIndex === 0"}],staticClass:"vc-chrome-fields"},[_c('div',{staticClass:"vc-chrome-field"},[(!_vm.hasAlpha)?_c('ed-in',{attrs:{"label":"hex","value":_vm.colors.hex},on:{"change":_vm.inputChange}}):_vm._e(),_vm._v(" "),(_vm.hasAlpha)?_c('ed-in',{attrs:{"label":"hex","value":_vm.colors.hex8},on:{"change":_vm.inputChange}}):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fieldsIndex === 1),expression:"fieldsIndex === 1"}],staticClass:"vc-chrome-fields"},[_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"r","value":_vm.colors.rgba.r},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"g","value":_vm.colors.rgba.g},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"b","value":_vm.colors.rgba.b},on:{"change":_vm.inputChange}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"a","value":_vm.colors.a,"arrow-offset":0.01,"max":1},on:{"change":_vm.inputChange}})],1):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fieldsIndex === 2),expression:"fieldsIndex === 2"}],staticClass:"vc-chrome-fields"},[_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"h","value":_vm.hsl.h},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"s","value":_vm.hsl.s},on:{"change":_vm.inputChange}})],1),_vm._v(" "),_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"l","value":_vm.hsl.l},on:{"change":_vm.inputChange}})],1),_vm._v(" "),(!_vm.disableAlpha)?_c('div',{staticClass:"vc-chrome-field"},[_c('ed-in',{attrs:{"label":"a","value":_vm.colors.a,"arrow-offset":0.01,"max":1},on:{"change":_vm.inputChange}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"vc-chrome-toggle-btn",attrs:{"role":"button","aria-label":"Change another color definition"},on:{"click":_vm.toggleViews}},[_c('div',{staticClass:"vc-chrome-toggle-icon"},[_c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"},on:{"mouseover":_vm.showHighlight,"mouseenter":_vm.showHighlight,"mouseout":_vm.hideHighlight}},[_c('path',{attrs:{"fill":"#333","d":"M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.highlight),expression:"highlight"}],staticClass:"vc-chrome-toggle-icon-highlight"})])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photoshop_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photoshop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photoshop_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photoshop_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photoshop_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d32ff494_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photoshop_vue__ = __webpack_require__(66);
function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photoshop_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d32ff494_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photoshop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vc-photoshop', _vm.disableFields ? 'vc-photoshop__disable-fields' : ''],attrs:{"role":"application","aria-label":"PhotoShop color picker"}},[_c('div',{staticClass:"vc-ps-head",attrs:{"role":"heading"}},[_vm._v(_vm._s(_vm.head))]),_vm._v(" "),_c('div',{staticClass:"vc-ps-body"},[_c('div',{staticClass:"vc-ps-saturation-wrap"},[_c('saturation',{on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1),_vm._v(" "),_c('div',{staticClass:"vc-ps-hue-wrap"},[_c('hue',{attrs:{"direction":"vertical"},on:{"change":_vm.childChange},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}},[_c('div',{staticClass:"vc-ps-hue-pointer"},[_c('i',{staticClass:"vc-ps-hue-pointer--left"}),_c('i',{staticClass:"vc-ps-hue-pointer--right"})])])],1),_vm._v(" "),_c('div',{class:['vc-ps-controls', _vm.disableFields ? 'vc-ps-controls__disable-fields' : '']},[_c('div',{staticClass:"vc-ps-previews"},[_c('div',{staticClass:"vc-ps-previews__label"},[_vm._v(_vm._s(_vm.newLabel))]),_vm._v(" "),_c('div',{staticClass:"vc-ps-previews__swatches"},[_c('div',{staticClass:"vc-ps-previews__pr-color",style:({background: _vm.colors.hex}),attrs:{"aria-label":("New color is " + (_vm.colors.hex))}}),_vm._v(" "),_c('div',{staticClass:"vc-ps-previews__pr-color",style:({background: _vm.currentColor}),attrs:{"aria-label":("Current color is " + _vm.currentColor)},on:{"click":_vm.clickCurrentColor}})]),_vm._v(" "),_c('div',{staticClass:"vc-ps-previews__label"},[_vm._v(_vm._s(_vm.currentLabel))])]),_vm._v(" "),(!_vm.disableFields)?_c('div',{staticClass:"vc-ps-actions"},[_c('div',{staticClass:"vc-ps-ac-btn",attrs:{"role":"button","aria-label":_vm.acceptLabel},on:{"click":_vm.handleAccept}},[_vm._v(_vm._s(_vm.acceptLabel))]),_vm._v(" "),_c('div',{staticClass:"vc-ps-ac-btn",attrs:{"role":"button","aria-label":_vm.cancelLabel},on:{"click":_vm.handleCancel}},[_vm._v(_vm._s(_vm.cancelLabel))]),_vm._v(" "),_c('div',{staticClass:"vc-ps-fields"},[_c('ed-in',{attrs:{"label":"h","desc":"°","value":_vm.hsv.h},on:{"change":_vm.inputChange}}),_vm._v(" "),_c('ed-in',{attrs:{"label":"s","desc":"%","value":_vm.hsv.s,"max":100},on:{"change":_vm.inputChange}}),_vm._v(" "),_c('ed-in',{attrs:{"label":"v","desc":"%","value":_vm.hsv.v,"max":100},on:{"change":_vm.inputChange}}),_vm._v(" "),_c('div',{staticClass:"vc-ps-fields__divider"}),_vm._v(" "),_c('ed-in',{attrs:{"label":"r","value":_vm.colors.rgba.r},on:{"change":_vm.inputChange}}),_vm._v(" "),_c('ed-in',{attrs:{"label":"g","value":_vm.colors.rgba.g},on:{"change":_vm.inputChange}}),_vm._v(" "),_c('ed-in',{attrs:{"label":"b","value":_vm.colors.rgba.b},on:{"change":_vm.inputChange}}),_vm._v(" "),_c('div',{staticClass:"vc-ps-fields__divider"}),_vm._v(" "),_c('ed-in',{staticClass:"vc-ps-fields__hex",attrs:{"label":"#","value":_vm.hex},on:{"change":_vm.inputChange}})],1),_vm._v(" "),(_vm.hasResetButton)?_c('div',{staticClass:"vc-ps-ac-btn",attrs:{"aria-label":"reset"},on:{"click":_vm.handleReset}},[_vm._v(_vm._s(_vm.resetLabel))]):_vm._e()]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"github-fork-ribbon",attrs:{"href":"https://github.com/xiaokaike/vue-color","title":"Fork me on GitHub"}},[_vm._v("Fork me on GitHub")]),_vm._v(" "),_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-bg",style:({'background-color': _vm.bgc})}),_vm._v(" "),_c('div',{staticClass:"header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"demo-item"},[_c('chrome-picker',{attrs:{"value":_vm.colors},on:{"input":_vm.updateValue}}),_vm._v(" "),_c('h2',[_vm._v("Chrome")])],1)])]),_vm._v(" "),_c('div',{staticClass:"demo-container"},[_c('div',{staticClass:"demo-list"},[_c('div',{staticClass:"demo-item"},[_c('sketch-picker',{model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}),_vm._v(" "),_c('h2',[_vm._v("Sketch")])],1),_vm._v(" "),_c('div',{staticClass:"demo-item"},[_c('photoshop-picker',{on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}),_vm._v(" "),_c('h2',[_vm._v("Photoshop")])],1)]),_vm._v(" "),_c('div',{staticClass:"demo-list"},[_c('div',{staticClass:"demo-item"},[_c('material-picker',{model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}),_vm._v(" "),_c('h2',[_vm._v("Material")])],1),_vm._v(" "),_c('div',{staticClass:"demo-item"},[_c('slider-picker',{model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}),_vm._v(" "),_c('h2',[_vm._v("Slider")])],1)]),_vm._v(" "),_c('div',{staticClass:"demo-list"},[_c('div',{staticClass:"demo-item"},[_c('compact-picker',{model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}),_vm._v(" "),_c('h2',[_vm._v("Compact")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('grayscale-picker',{attrs:{"value":_vm.colors},on:{"input":_vm.updateValue}}),_vm._v(" "),_c('h2',[_vm._v("Grayscale")])],1),_vm._v(" "),_c('div',{staticClass:"demo-item"},[_c('swatches-picker',{model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}),_vm._v(" "),_c('h2',[_vm._v("Swatches")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-wrap"},[_c('div',{staticClass:"intro"},[_c('h1',[_vm._v("Vue-color")]),_vm._v(" "),_c('p',{attrs:{"role":"presentation"}},[_vm._v("A Collection of Color Pickers from Sketch, Photoshop, Chrome, Github, Twitter, Material Design & more")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.7cae6a0292b11bd6839f.js